/** @jsx jsx */
import PropTypes from 'prop-types'
import { jsx, Container } from 'theme-ui'
import Quote from '~/components/Generic/Quote'

const ProductQuote = ({ quote }) => {
  return (
    <Container
      variant="fullWidth"
      sx={{
        backgroundColor: 'altBackground',
        marginBottom: ['32px', null, '48px'],
        marginTop: ['20px', '24px', '48px']
      }}
    >
      <Container>
        <Quote quote={quote} />
      </Container>
    </Container>
  )
}

ProductQuote.propTypes = {
  quote: PropTypes.shape({
    author: PropTypes.string,
    location: PropTypes.string,
    body: PropTypes.shape({})
  })
}

export default ProductQuote
